import styled from "styled-components";

const Wrapper = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const EmptyPlayer = () => {
  return (
    <Wrapper>
      <h5>Content is not availiable.</h5>
    </Wrapper>
  );
};

export default EmptyPlayer;
